import { TwinkleUpdater } from "./TwinkleUpdater";
export async function loadTwinkleUpdater(engine, refresh = true) {
    await engine.addParticleUpdater("twinkle", () => new TwinkleUpdater(), refresh);
}
